module.exports = __webpack_public_path__ + "static/media/elegir_b-01.e44b3c3e.svg";